<ngx-page-container>
  <h1>Activity Statistics</h1>
  <hr />
  <ngx-loading-spinner [loading]="loading"></ngx-loading-spinner>
  <div *ngIf="!loading">
    <br>
    <div>
        <ng2-smart-table [settings]="settings" [source]="source"></ng2-smart-table>
    </div>
    <br />
    <a [routerLink]="[]" (click)="downloadXlsx()">Generate XLSX</a>
  </div>
</ngx-page-container>
